module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-xhr-backend/index.js
// module id = 468
// module chunks = 114276838955818